import * as React from 'react';
import cx from 'classnames';
import wrapStore from '@src/utils/wrap-store';
import ModalContainer from '@src/components/modal-container';
import Link from '@src/components/link';
import AppointmentSuccessModalStore, { SHARE_CONFIG } from './store';
import CloseBtn from '@src/business-components/close-btn';
import getPageLocalesData from '@src/global-locales/get-page-locales-data';
const pageLocalesData = getPageLocalesData();

const styles = require('./index.less');

/**
 * 弹窗模板, 可以快速套用修改
 */
const AppointmentSuccessModal = ({ store, onClose }) => {
  store.use();
  if (onClose) {
    store.onClose = onClose;
  }
  const renderList = () => {
    return (
      <div className={cx(styles.listBox, store.itemList?.length > 3 && styles.oneLine)}>
        {store.itemList.map(({ channel, link }, key) => {
          return (
            <img
              alt=""
              src={SHARE_CONFIG?.[channel]?.icon}
              className={styles.listItem}
              key={key}
              onClick={() => {
                store.onRedirectLink(link);
              }}
            />
          );
        })}
      </div>
    );
  };

  return (
    <ModalContainer modalState={store.isOpen}>
      <div className={cx(styles.modalBOx)}>
        <div className={styles.closeBox}>
          <CloseBtn onClose={store.onClickClose} />
        </div>

        <div className={styles.bg} />

        <div className={styles.content}>
          <div className={styles.title}>
            {store.email} {pageLocalesData.reserve.success.title}
          </div>

          <div className={styles.tips}>[ {pageLocalesData.reserve.success.tips} ]</div>

          {renderList()}
        </div>

        <Link className={styles.btnConfirm} onClick={store.onClickClose}>
          {pageLocalesData.reserve.success.btnConfirm}
        </Link>
      </div>
    </ModalContainer>
  );
};

export default wrapStore(AppointmentSuccessModal, AppointmentSuccessModalStore);
